module.exports = __webpack_public_path__ + "static/media/github.dd24e5cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/github.png
// module id = 80
// module chunks = 0